import React, { createContext, useState, useCallback } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null); // null = no autenticado
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  // Iniciar sesión
  const login = useCallback(async (email, password) => {
    setCargando(true);
    setError('');

    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Credenciales incorrectas');
        setCargando(false);
        return false;
      }

      // Guardar usuario en estado y en sessionStorage
      setUsuario(data.usuario);
      sessionStorage.setItem('admin_user', JSON.stringify(data.usuario));
      setCargando(false);
      return true;

    } catch (err) {
      setError('Error al conectar con el servidor');
      setCargando(false);
      return false;
    }
  }, []);

  // Cerrar sesión
  const logout = useCallback(() => {
    setUsuario(null);
    sessionStorage.removeItem('admin_user');
    setError('');
  }, []);

  // Restaurar sesión desde sessionStorage al montar
  const restaurarSesion = useCallback(() => {
    const guardado = sessionStorage.getItem('admin_user');
    if (guardado) {
      try {
        setUsuario(JSON.parse(guardado));
      } catch {
        sessionStorage.removeItem('admin_user');
      }
    }
  }, []);

  // Verificar si está autenticado
  const estaAutenticado = usuario !== null;

  const value = {
    usuario,
    cargando,
    error,
    estaAutenticado,
    login,
    logout,
    restaurarSesion,
    setError,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
